import getLang from 'I18n/utils/getLang';
import { useCallback } from 'react';
import { getAppRecommendationTypes } from '../utils/getAppRecommendationTypes';
import { useTrackStandaloneEvent } from './useTrackStandaloneEvent';
export function useTrackMarketplaceClickResultItem() {
  const trackStandaloneEvent = useTrackStandaloneEvent();
  const trackClickResultItem = useCallback(eventProps => {
    trackStandaloneEvent('Marketplace Interaction', Object.assign({}, eventProps, {
      action: 'click result item'
    }));
  }, [trackStandaloneEvent]);
  return {
    trackClickResultItem
  };
}
export function useTrackAppMarketplaceClickResultItem() {
  const trackStandaloneEvent = useTrackStandaloneEvent();
  const trackClickResultItem = useCallback((result, eventProps) => {
    var _getAppRecommendation;
    trackStandaloneEvent('Marketplace Interaction', Object.assign({}, eventProps, {
      type: 'integration',
      action: 'click result item',
      value: result.slug,
      applicationId: parseInt(result.sourceId, 10),
      isRecommended: !!result.recommendation,
      recommendationType: (_getAppRecommendation = getAppRecommendationTypes(result)) !== null && _getAppRecommendation !== void 0 ? _getAppRecommendation : undefined,
      preferredLanguage: eventProps.preferredLanguage || getLang()
    }));
  }, [trackStandaloneEvent]);
  return {
    trackClickResultItem
  };
}
export function useTrackSolutionsDirectoryClickResultItem() {
  const trackStandaloneEvent = useTrackStandaloneEvent();
  const trackClickResultItem = useCallback((result, eventProps) => {
    trackStandaloneEvent('Marketplace Interaction', Object.assign({}, eventProps, {
      type: 'solution provider',
      action: 'click result item',
      value: result.slug,
      tier: result.tier
    }));
  }, [trackStandaloneEvent]);
  return {
    trackClickResultItem
  };
}